<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Zone bearbeiten') }}</h1>
        </div>

        <div class="">
            <form @submit.prevent="form.put(route('admin.zones.update', zone))">
                <form-fields :form="form" :zone="zone" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'zone',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    uid: this.zone.uid,
                    name: this.zone.name,
                    description: this.zone.description,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>